module.exports = __webpack_public_path__ + "img/linkfail.f09504c0.svg";